// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toolbar-expediente-width-menu{background:#f5f5f5!important;box-shadow:0 3px 3px 0 rgba(0,0,0,.09)!important;left:275px;position:fixed;right:0;top:60px;z-index:1}.ag-container{display:flex;flex-direction:column;height:100%!important}.toolbar-expediente-no-menu{background:#f5f5f5!important;box-shadow:0 3px 3px 0 rgba(0,0,0,.09)!important;color:#727891!important;left:0;position:fixed;right:0;top:60px;z-index:1}.info-expediente{height:30px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
